// extracted by mini-css-extract-plugin
module.exports = {"dateRangeArrows":"_dateRangeArrows--1AOw3","dateRangeArrow":"_dateRangeArrow---BKDs"};